const DEBUG_KEY = 'ENABLE_PAYMENT_DEBUG';

export const debugLogger = {
  isEnabled() {
    if (typeof window === 'undefined') return false;
    
    return (
      localStorage.getItem(DEBUG_KEY) === 'true' ||
      window.ENABLE_PAYMENT_DEBUG === true ||
      process.env.REACT_APP_ENABLE_PAYMENT_DEBUG === 'true'
    );
  },

  log(...args) {
    if (this.isEnabled()) {
      console.log(...args);
    }
  },

  error(...args) {
    if (this.isEnabled()) {
      console.error(...args);
    }
  },

  warn(...args) {
    if (this.isEnabled()) {
      console.warn(...args);
    }
  },

  group(label) {
    if (this.isEnabled()) {
      console.group(label);
    }
  },

  groupEnd() {
    if (this.isEnabled()) {
      console.groupEnd();
    }
  },

  enable() {
    localStorage.setItem(DEBUG_KEY, 'true');
    console.log('✅ Payment debugging enabled. Reload the page to see debug logs.');
  },

  disable() {
    localStorage.removeItem(DEBUG_KEY);
    console.log('🔕 Payment debugging disabled. Reload the page.');
  },

  status() {
    const enabled = this.isEnabled();
    console.log(`Payment Debug Status: ${enabled ? '✅ ENABLED' : '🔕 DISABLED'}`);
    if (!enabled) {
      console.log('To enable: Run enablePaymentDebug() in console');
    }
    return enabled;
  }
};

if (typeof window !== 'undefined') {
  window.enablePaymentDebug = () => debugLogger.enable();
  window.disablePaymentDebug = () => debugLogger.disable();
  window.paymentDebugStatus = () => debugLogger.status();
}

